import {FunctionComponent, useEffect, useState} from "react";

interface IActualTimeLine {
    dayWidth: number;
    startOffset: number;
    singleDay: boolean;
    contentWidth: number | undefined;
}

export const ActualTimeLine: FunctionComponent<IActualTimeLine> = ({
                                                                       dayWidth,
                                                                       startOffset,
                                                                       singleDay,
                                                                       contentWidth,
                                                                   }): JSX.Element => {
    const [leftPosition, setLeftPosition] = useState(startOffset);
    // @ts-ignore
    const [timeOffsets, setTimeOffsets] = useState([]);
    const [maybeUnloadedElementSnapshot, setMaybeUnloadedElementSnapshot] =
        useState(0);
    const [displayState, setDisplayState] = useState("none");
    const [sidebarWidth, setSidebarWidth] = useState(0);


    const tryGetDispositionContent = (runOnce) => {
        // @ts-ignore
        if (
            document.getElementById("dispo_content") &&
            maybeUnloadedElementSnapshot !=
            parseInt(document.getElementById("dispo_content").style.width)
        ) {
            // @ts-ignore
            setMaybeUnloadedElementSnapshot(
                parseInt(document.getElementById("dispo_content").style.width),
            );
        } else {
            if (!runOnce) setTimeout(tryGetDispositionContent, 200);
        }
    };

    const tryGetSidebarWidth = () => {
        // @ts-ignore
        if (
            document.getElementsByClassName("MuiDrawer-root")[0] &&
            sidebarWidth === 0
        ) {
            // @ts-ignore
            setSidebarWidth(
                parseInt(
                    document.getElementsByClassName("MuiDrawer-root")[0]
                        ?.clientWidth,
                ),
            );
        } else {
            setTimeout(tryGetSidebarWidth, 200);
        }
    };

    tryGetDispositionContent(true);
    tryGetSidebarWidth();


    useEffect(() => {
        setMaybeUnloadedElementSnapshot(0);
        setTimeOffsets([]);
        setLeftPosition(0);
        setDisplayState("none");

        tryGetDispositionContent(true);
        tryGetSidebarWidth();
    }, [document.getElementsByClassName("MuiDrawer-root")[0]?.clientWidth]);

    if (timeOffsets.length == 0 && maybeUnloadedElementSnapshot != 0) {
        const temp = [];
        const width = ((dayWidth / 100) * contentWidth) / 96;
        const widthSingleDay = (dayWidth / 100) * maybeUnloadedElementSnapshot;

        if (singleDay) {
            for (let i = 0; i < 60; i++) {
                temp.push(widthSingleDay * (i / 60));
            }
        } else {
            for (let i = 0; i < 96; i++) {
                temp.push(width * i);
            }
        }

        setTimeOffsets(temp);
    }

    const getQurterHourIndex = () => {
        const currentDate = new Date();
        const currentHour = currentDate.getHours();
        const currentMinute = currentDate.getMinutes();

        return Math.floor((currentHour * 60 + currentMinute) / 15) + 1;
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (leftPosition == startOffset) {
                setLeftPosition(0.00001 + startOffset);
                return;
            }

            if (displayState == "none") {
                setDisplayState("unset");
            }

            if (singleDay) {
                // @ts-ignore
                setLeftPosition(
                    timeOffsets[new Date().getMinutes()] +
                    new Date().getHours() *
                    ((dayWidth / 100) * maybeUnloadedElementSnapshot),
                );
            } else {
                // @ts-ignore
                setLeftPosition(
                    timeOffsets[getQurterHourIndex()] + startOffset,
                );
            }
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [leftPosition]);

    return (
        <div
            style={{
                position: "absolute",
                zIndex: 1010,
                left: leftPosition,
                width: 1,
                height: "5000px",
                backgroundColor: "red",
                display: displayState,
                // @ts-ignore
            }}
        />
    );
};
